import { Typography, Container, Grid, Box } from '@mui/material';
import { images } from 'config/images';
import { theme } from 'theme';

const Item = ({ children }: { children: React.ReactNode }) => (
   <div>
      {children}
   </div>
);

export const CleanSection = () => {
   return (
      <Container sx={{ marginTop: "2.5rem" }} >
         <Typography variant='h2' sx={{ marginBottom: "2rem", textAlign: "center" }}>
            E-SmartWash Laundromat for {' '}
            <Box component="span" sx={{ color: theme.palette.secondary.main }}>
               Fresh, Clean Clothes
            </Box>
         </Typography>

         <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} marginTop={"3rem"} paddingBottom={"3rem"}>
            <Grid item xs={12} md={6}>
               <Item>
                  <picture>
                     <img src={images.home.moreInfo.mission} alt="Fresh, Clean Clothes" height={"370"} width={"100%"} style={{ aspectRatio: "4/4", objectFit: "cover" }} />
                  </picture>
               </Item>
            </Grid>
            <Grid item xs={12} md={6} display={"flex"} flexDirection={"column"} justifyContent={"center"}>
               <Item >
                  <Typography sx={{ marginTop: { xs: "1.5rem", md: 0 } }}>
                     If you want minimalism with quality services to support the environment, our laundromat in Hamilton, NZ, will meet all your needs. At E-SmartWash, you can use our mobile app to check if machines are available and monitor cycle progress. Make your laundry time efficient and productive at our Hamilton laundromat!
                  </Typography>
                  <Typography marginTop={"2rem"} >
                     Our machines are built to reduce environmental impact. Our smart washers and dryers adjust their functions based on your load size and optimise energy and water consumption. At the end of each wash cycle, you get clean clothes that smell nice and fresh!
                  </Typography>
               </Item>
            </Grid>
         </Grid>
      </Container>
   );
}
